import {getBlockModel} from '../block/block'
import {getBlockShapeModel} from '../block/shape'
import {getBlockIconModel} from '../block/icon'
import {
    ACTION_CATCH_EXCEPTION,
    ACTION_CATCH_OUTCOME,
    ACTION_DATASTORE,
    ACTION_DATASTORE_OPERATION,
    ACTION_END,
    ACTION_FOR_EACH,
    ACTION_FOR_EACH_BREAK,
    ACTION_FOR_EACH_CONTINUE,
    ACTION_JOIN,
    ACTION_RUN_WORKFLOW,
    ACTION_SPLIT,
    ACTION_START,
    ACTION_TRIGGER_ACKNOWLEDGE,
    ACTION_WAIT,
    MODEL_ENTITY_ACTION,
    WORKFLOW_PATH_BEGIN,
    WORKFLOW_PATH_END
} from '../index'
import {scheduleIntervals, WORKFLOW_TRIGGER_INTERVAL_DAILY, WORKFLOW_TRIGGER_TYPE_SCHEDULE} from '../workflow-triggers'
import {datastoreOperationTypes} from './datastore-action'

export const workflowActions = Object.freeze({

    // [ACTION_ADD_LOG]: getBlockModel(false, 'Add log',
    //     [
    //         getBlockShapeModel(),
    //         getBlockIconModel('ballot')
    //     ], {
    //         entity: MODEL_ENTITY_ACTION,
    //         key: ACTION_ADD_LOG,
    //         description: 'Add a log message to the passed object',
    //         object: null,
    //         body: null
    //     }),

    // [ACTION_ADD_NOTE]: getBlockModel(false, 'Add note',
    //     [
    //         getBlockShapeModel(),
    //         getBlockIconModel('notes-medical')
    //     ], {
    //         entity: MODEL_ENTITY_ACTION,
    //         key: ACTION_ADD_NOTE,
    //         description: 'Add a note to the passed object',
    //         object: null,
    //         body: null
    //     }),

    // [ACTION_APPROVAL]: getBlockModel(false, 'Request Approval',
    //     [
    //         getBlockShapeModel(),
    //         getBlockIconModel('check')
    //     ], {
    //         entity: MODEL_ENTITY_ACTION,
    //         key: ACTION_APPROVAL,
    //         description: 'Request approval from one or more people.',
    //         assignedTo: null,
    //         numberOfApprovals: 1,
    //         numberOfDeclines: 1,
    //         approved_path: null,  // block id
    //         declined_path: null, // block id
    //         exception_path: null, // block id
    //         date: {
    //             warn: null,
    //             late: null,
    //             escalation: null,
    //             expiry: null
    //         },
    //         workflow: {
    //             warn: null,
    //             late: null,
    //             escalation: null,
    //             expiry: null
    //         }
    //     }, {
    //         paths: {
    //             from: {min: 0, max: 3},
    //             to: {min: 1, max: -1}
    //         }
    //     }),

    // [ACTION_CREATE_LINE_ITEM]: getBlockModel(false, 'Create a line item',
    //     [
    //         getBlockShapeModel(),
    //         getBlockIconModel('layer-plus')
    //     ], {
    //         entity: MODEL_ENTITY_ACTION,
    //         key: ACTION_CREATE_LINE_ITEM,
    //         description: 'Create a line item for received document.',
    //         objectId: null,
    //         mapping: null
    //     }),

    // Singleton action

    // [ACTION_SEND_EMAIL]: getBlockModel(false, 'Send an email',
    //     [
    //         getBlockShapeModel(),
    //         getBlockIconModel('envelope')
    //     ], {
    //         entity: MODEL_ENTITY_ACTION,
    //         key: ACTION_SEND_EMAIL,
    //         description: 'Send an email',
    //         email: {
    //             to: null,
    //             subject: null,
    //             body: null
    //         }
    //     }, {
    //         paths: {
    //             from: {min: 0, max: 1},
    //             to: {min: 1, max: -1}
    //         }
    //     }),

    // [ACTION_SEND_NOTIFICATION]: getBlockModel(false, 'Notify User',
    //     [
    //         getBlockShapeModel(),
    //         getBlockIconModel('comments')
    //     ], {
    //         entity: MODEL_ENTITY_ACTION,
    //         key: ACTION_SEND_NOTIFICATION,
    //         description: 'Notify User',
    //         member: null // uuid
    //     }, {
    //         paths: {
    //             from: {min: 0, max: 1},
    //             to: {min: 1, max: -1}
    //         }
    //     }),

    // [ACTION_CREATE_DOCUMENT]: getBlockModel(false, 'Create a Document',
    //     [
    //         getBlockShapeModel(),
    //         getBlockIconModel('plus')
    //     ], {
    //         entity: MODEL_ENTITY_ACTION,
    //         key: ACTION_CREATE_DOCUMENT,
    //         description: 'Create a new document with API.',
    //         objectId: null,
    //         type: null,
    //         mapping: null
    //     }, {
    //         paths: {
    //             from: {min: 0, max: -1},
    //             to: {min: 1, max: -1},
    //         }
    //     }),

    // [ACTION_UPDATE_FIELD]: getBlockModel(false, 'Update Document',
    //     [
    //         getBlockShapeModel(),
    //         getBlockIconModel('file-edit')
    //     ], {
    //         entity: MODEL_ENTITY_ACTION,
    //         key: ACTION_UPDATE_FIELD,
    //         description: 'Update field for passed object.',
    //         objectId: null,
    //         mapping: null
    //     }, {
    //         paths: {
    //             from: {min: 0, max: 1},
    //             to: {min: 1, max: -1},
    //         }
    //     }),

    [ACTION_FOR_EACH]: getBlockModel(false, 'Loop', [
        getBlockShapeModel(),
        getBlockIconModel('repeat-1-alt')
    ], {
        entity: MODEL_ENTITY_ACTION,
        key: ACTION_FOR_EACH,
        description: 'Loop the items of an invoice or collection.',
        /*
         * loopProp {String, null}- path to loop property (workflowObject.data[someIdx].name
         * null for SEARCH module type (whole interface object is iterable instance)
         * */
        loopProp: null,
        objectId: null,
        [WORKFLOW_PATH_BEGIN]: null, // block "to" id
        [WORKFLOW_PATH_END]: null // block "to" id
    }, {
        paths: {
            from: {min: 0, max: 2},
            to: {min: 1, max: -1}
        }
    }),

    [ACTION_FOR_EACH_BREAK]: getBlockModel(false, 'Loop break', [
        getBlockShapeModel(),
        getBlockIconModel('repeat-1-alt')
    ], {
        entity: MODEL_ENTITY_ACTION,
        key: ACTION_FOR_EACH_BREAK,
        description: 'This step exits the current loop.',
        loopBlockId: null
    }, {
        paths: {
            from: {min: 0, max: 1},
            to: {min: 1, max: -1}
        }
    }),

    [ACTION_FOR_EACH_CONTINUE]: getBlockModel(false, 'Loop continue', [
        getBlockShapeModel(),
        getBlockIconModel('repeat-1-alt')
    ], {
        entity: MODEL_ENTITY_ACTION,
        key: ACTION_FOR_EACH_CONTINUE,
        description: 'This step continues the current loop.',
        loopBlockId: null
    }, {
        paths: {
            from: {min: 0, max: 1},
            to: {min: 1, max: -1}
        }
    }),

    [ACTION_WAIT]: getBlockModel(false, 'Wait', [
        getBlockShapeModel(),
        getBlockIconModel('hourglass-start')
    ], {
        entity: MODEL_ENTITY_ACTION,
        key: ACTION_WAIT,
        description: 'This action makes the workflow wait for the specified period of time.',
        delay: null
    }, {
        paths: {
            from: {min: 0, max: 1},
            to: {min: 1, max: -1}
        }
    }),

    [ACTION_JOIN]: getBlockModel(false, 'Join Paths', [
        getBlockShapeModel(),
        getBlockIconModel('code-merge')
    ], {
        entity: MODEL_ENTITY_ACTION,
        key: ACTION_JOIN,
        description: 'This takes one or more pipeline and turns it into one pipeline.',
        runOnce: true
    }, {
        paths: {
            from: {min: 0, max: 1},
            to: {min: 1, max: -1}
        }
    }),

    [ACTION_SPLIT]: getBlockModel(false, 'Split paths', [
        getBlockShapeModel(),
        getBlockIconModel('code-branch')
    ], {
        entity: MODEL_ENTITY_ACTION,
        key: ACTION_SPLIT,
        description: 'This takes one pipeline and splits it into multiple pipelines.',
        runOnce: true
    }, {
        paths: {
            from: {min: 0, max: 2},
            to: {min: 1, max: -1}
        }
    }),

    [ACTION_RUN_WORKFLOW]: getBlockModel(false, 'Run Workflow', [
        getBlockShapeModel(),
        getBlockIconModel('project-diagram')
    ], {
        entity: MODEL_ENTITY_ACTION,
        key: ACTION_RUN_WORKFLOW,
        description: 'The workflow parameter links to another workflow which will be run before the process continue.',
        workflowUuid: null,
        team_uuid: null
    }, {
        paths: {
            from: {min: 0, max: 1},
            to: {min: 1, max: -1}
        }
    }),

    // [ACTION_SEND_TO_INTEGRATION]: getBlockModel(false, 'Send to Integration',
    //     [
    //         getBlockShapeModel(),
    //         getBlockIconModel('network-wired')
    //     ], {
    //         entity: MODEL_ENTITY_ACTION,
    //         key: ACTION_SEND_TO_INTEGRATION,
    //         description: 'Trigger the document to be sent to the integration.',
    //         integration: null // -> integration code
    //     }),
    //
    // [ACTION_SET_STATUS]: getBlockModel(false, 'Set status',
    //     [
    //         getBlockShapeModel(),
    //         getBlockIconModel('pen-square')
    //     ], {
    //         entity: MODEL_ENTITY_ACTION,
    //         key: ACTION_SET_STATUS,
    //         description: 'Set the status of a document.',
    //         status: ''
    //     }),

    // Singleton action
    [ACTION_START]: getBlockModel(ACTION_START, 'Start', [
        getBlockShapeModel(),
        getBlockIconModel('map-pin')
    ], {
        entity: MODEL_ENTITY_ACTION,
        key: ACTION_START,
        description: 'Start of the workflow.',
        trigger: {
            type: WORKFLOW_TRIGGER_TYPE_SCHEDULE, // default

            // specify for WORKFLOW_TRIGGER_TYPE_SCHEDULE:
            interval: {
                cron: scheduleIntervals[WORKFLOW_TRIGGER_INTERVAL_DAILY].cron,
                timezone: 'Australia/Brisbane'
            }
            // specify for WORKFLOW_TRIGGER_TYPE_EVENT:
            // documentTypeUuid: null,
            // eventTypeCode: null
        }
    }, {
        paths: {
            from: {min: 0, max: 1},
            to: {min: 0, max: 0}
        }
    }, {
        isEditableModel: true
    }, 100, 200),

    [ACTION_END]: getBlockModel(ACTION_END, 'End', [
        getBlockShapeModel(),
        getBlockIconModel('flag-checkered')
    ], {
        entity: MODEL_ENTITY_ACTION,
        key: ACTION_END,
        description: 'End of the workflow. No settings required.'
    }, {
        paths: {
            from: {min: 0, max: 0},
            to: {min: 1, max: -1}
        }
    }, {
        isEditableModel: false
    }, 400, 200),

    [ACTION_CATCH_EXCEPTION]: getBlockModel(false, 'Catch error', [
        getBlockShapeModel(),
        getBlockIconModel('exclamation-triangle')
    ], {
        entity: MODEL_ENTITY_ACTION,
        key: ACTION_CATCH_EXCEPTION,
        description: 'If an exception occurs in a flow the flow should jump to this object'
    }, {
        paths: {
            from: {min: 0, max: -1},
            to: {min: 1, max: -1}
        }
    }, {
        isEditableModel: false
    }),

    [ACTION_CATCH_OUTCOME]: getBlockModel(false, 'Catch outcome', [
        getBlockShapeModel(),
        getBlockIconModel('arrow-alt-to-right')
    ], {
        entity: MODEL_ENTITY_ACTION,
        key: ACTION_CATCH_OUTCOME,
        description: 'For any paths that don\'t have an outcome, the flow should jump to this object.'
    }, {
        paths: {
            from: {min: 0, max: -1},
            to: {min: 1, max: -1}
        }
    }, {
        isEditableModel: false
    }),

    [ACTION_DATASTORE]: getBlockModel(false, 'Datastore', [
        getBlockShapeModel(),
        getBlockIconModel('file-alt')
    ], {
        entity: MODEL_ENTITY_ACTION,
        key: ACTION_DATASTORE,
        description: 'Create and store an empty data structure and define its interface.'
        // data_type: WORKFLOW_OBJ_TYPE_DATASTORE_LIST => NOTE: stored inside datastore object like type
    }, {
        paths: {
            from: {min: 0, max: -1},
            to: {min: 1, max: -1}
        }
    }),

    [ACTION_DATASTORE_OPERATION]: getBlockModel(false, 'Data operation', [
        getBlockShapeModel(),
        getBlockIconModel('file-signature')
    ], {
        entity: MODEL_ENTITY_ACTION,
        key: ACTION_DATASTORE_OPERATION,
        description: 'Update data store object.',
        operation_type: datastoreOperationTypes.add.key,
        operation_args: [
            // {"name": {"isMap": false, "value":  "Juan"}}
        ],
        objectId: null
    }, {
        paths: {
            from: {min: 0, max: -1},
            to: {min: 1, max: -1}
        }
    }),

    [ACTION_TRIGGER_ACKNOWLEDGE]: getBlockModel(false, 'Trigger acknowledge', [
        getBlockShapeModel(),
        getBlockIconModel('conveyor-belt-alt')
    ], {
        entity: MODEL_ENTITY_ACTION,
        key: ACTION_TRIGGER_ACKNOWLEDGE,
        description: 'This block is used to mark an item as processed so that the trigger doesnt process it again.',
        processed: [], // list of processed item ids
        trigger_block: null // reference id to a peekable trigger block
    }, {
        paths: {
            from: {min: 0, max: -1},
            to: {min: 1, max: -1}
        }
    })

})

export const workflowActionList = Object.freeze(Object.values(workflowActions))
